import Colors from 'constants/Colors';

export default {
  labelTitle: {
    fontSize: '12px',
    fontWeight: 'bold',
    color: '#424242',
  },
  descriptionText: {
    margin: 0,
    fontSize: '12px',
    color: '#888',
  },
  iconModal: {
    margin: '25px 0px',
    backgroundColor: Colors.blueIconBg,
    color: Colors.blueIcon,
    borderRadius: '50%',
    width: '48px',
    height: '48px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  titleModal: {
    fontSize: '18px',
    textAlign: 'center',
    marginBottom: '8px',
  },
};
